<template>
  <d2-container>
    <template slot="header">
      <!-- <cpt @calculate="addNum"></cpt> -->
      <el-date-picker
          v-model="selectedTime"
          type="datetimerange"
          range-separator="至"
          start-placeholder="开始日期"
          end-placeholder="结束日期"

          align="right"
          :default-time="['00:00:00', '23:59:59']"
          style="margin-top:5px;margin-right: 20px;"
      ></el-date-picker>
      <el-input
          @keyup.enter.native="getSearch"
          v-model="listQuery.orderId"
          style="width: 250px;margin-right: 20px;"
          class="filter-item"
          placeholder="请输入订单id"
          size="small"
          clearable
      ></el-input>
      <el-input
          @keyup.enter.native="getSearch"
          v-model="listQuery.accountId"
          style="width: 250px;margin-right: 20px;"
          class="filter-item"
          placeholder="请输入用户id"
          size="small"
          clearable
      ></el-input>
      <el-select
          @keyup.enter.native="getSearch"
          v-model="listQuery.payStatus"
          clearable
          placeholder="请选择支付状态"
          size="small"
          style="margin-top:5px;margin-right: 20px;"
      >
        <el-option
            v-for="item in payList"
            :key="item.value"
            :label="item.label"
            :value="item.value"
        ></el-option>
      </el-select>
      <!-- <br> -->
      <el-select
          @keyup.enter.native="getSearch"
          v-model="listQuery.status"
          clearable
          placeholder="请选择订单状态"
          size="small"
          style="margin-top:5px;margin-right: 20px;"
      >
        <el-option
            v-for="item in statusList"
            :key="item.value"
            :label="item.label"
            :value="item.value"
        ></el-option>
      </el-select>
      <el-button
          @click="getSearch()"
          class="filter-item"
          type="primary"
          icon="search"
          size="small"
          style="margin-top:5px;"
      >搜索</el-button>
      <el-button
          @click="clearBoth"
          class="filter-item"
          type="success"
          icon="search"
          size="small"
          style="margin-top:5px;"
      >清空</el-button>
    </template>
    <el-table
      size="small"
      :key="tableKey"
      stripe
      border
      highlight-current-row
      style="margin-top: 20px"
      :data="list"
    >
      <el-table-column type="expand">
        <template slot-scope="props">

          <el-table
              size="mini"
              :key="tableKey"
              border
              :data="props.row.orderItems"
              style="margin-left: 50px"
          >
            <el-table-column align="center" label="子订单ID">
              <template slot-scope="scope">
                <span>{{ scope.row.id }}</span>
              </template>
            </el-table-column>
            <el-table-column label="产品图标" align="center">
              <template slot-scope="scope">
                <img :src="scope.row.productCover" style="width: 80px; height: 80px; object-fit: cover" />
              </template>
            </el-table-column>
            <el-table-column label="产品名称" align="center">
              <template slot-scope="scope">
                <span>{{ scope.row.productName }}</span>
              </template>
            </el-table-column>

            <el-table-column label="规格" align="center">
              <template slot-scope="scope">
                <spec-view :list="scope.row.specList">
                </spec-view>
              </template>
            </el-table-column>

            <el-table-column label="原价" align="center">
              <template slot-scope="scope">
                <span>{{ scope.row.originalPrice }}</span>
              </template>
            </el-table-column>
            <el-table-column label="优惠金额" align="center">
              <template slot-scope="scope">
                <span>{{ scope.row.discountPrice }}</span>
              </template>
            </el-table-column>
            <el-table-column label="需支付金额" align="center">
              <template slot-scope="scope">
                <span>{{ scope.row.payPrice }}</span>
              </template>
            </el-table-column>
            <el-table-column label="优惠券" align="center">
              <template slot-scope="scope">
                <span>{{ scope.row.couponName }}</span>
              </template>
            </el-table-column>
            <el-table-column label="优惠券金额" align="center">
              <template slot-scope="scope">
                <span>{{ scope.row.couponPrice }}</span>
              </template>
            </el-table-column>
            <el-table-column label="状态" align="center">
              <template slot-scope="scope">
                <el-tag v-if="scope.row.status === 0" type="info">已关闭</el-tag>
                <el-tag v-if="scope.row.status === 1" >待支付</el-tag>
                <el-tag v-if="scope.row.status === 2" type="info">未支付取消</el-tag>
                <el-tag v-if="scope.row.status === 3" type="info">已退款</el-tag>
                <el-tag v-if="scope.row.status === 4" type="warning">待确认</el-tag>
                <el-tag v-if="scope.row.status === 5" type="danger">进行中</el-tag>
                <el-tag v-if="scope.row.status === 6" type="success">已完成</el-tag>
              </template>
            </el-table-column>
            <el-table-column align="center" label="更新时间">
              <template slot-scope="scope">
                <span>{{ scope.row.updateTime }}</span>
              </template>
            </el-table-column>
          </el-table>
        </template>
      </el-table-column>
      <el-table-column align="center" label="id">
        <template slot-scope="scope">
          <span>{{ scope.row.id }}</span>
        </template>
      </el-table-column>
      <el-table-column align="center" label="标题">
        <template slot-scope="scope">
          <span>{{ scope.row.title }}</span>
        </template>
      </el-table-column>
      <el-table-column align="center" label="下单用户" width="160">
        <template slot-scope="scope">
          <span
              style="cursor: pointer;color: dodgerblue;padding: 1px 4px;"
              @click="userDedtails(scope.row.accountId)"
          >{{scope.row.accountId}}</span>
        </template>
      </el-table-column>
      <el-table-column align="center" label="订单原价">
        <template slot-scope="scope">
          <span>{{scope.row.originalPrice}}</span>
        </template>
      </el-table-column>
      <el-table-column align="center" label="产品总价">
        <template slot-scope="scope">
          <span>{{scope.row.productTotalPrice}}</span>
        </template>
      </el-table-column>
      <el-table-column align="center" label="已付金额">
        <template slot-scope="scope">
          <span>{{scope.row.payPrice}}</span>
        </template>
      </el-table-column>
      <el-table-column label="状态" align="center">
        <template slot-scope="scope">
          <el-tag v-if="scope.row.status === 0" type="info">已关闭</el-tag>
          <el-tag v-if="scope.row.status === 1" >待支付</el-tag>
          <el-tag v-if="scope.row.status === 2" type="info">未支付取消</el-tag>
          <el-tag v-if="scope.row.status === 3" type="info">已退款</el-tag>
          <el-tag v-if="scope.row.status === 4" type="warning">待确认</el-tag>
          <el-tag v-if="scope.row.status === 5" type="danger">进行中</el-tag>
          <el-tag v-if="scope.row.status === 6" type="success">已完成</el-tag>
        </template>
      </el-table-column>

      <el-table-column align="center" label="下单时间">
        <template slot-scope="scope">
          <span>{{ scope.row.createTime }}</span>
        </template>
      </el-table-column>
      <el-table-column align="center" label="更新时间">
        <template slot-scope="scope">
          <span>{{ scope.row.updateTime }}</span>
        </template>
      </el-table-column>

      <el-table-column align="center" label="订单备注" :show-overflow-tooltip="true">
        <template slot-scope="scope">
          <span>{{scope.row.remark}}</span>
        </template>
      </el-table-column>
      <el-table-column align="center" label="客服备注" >
        <template slot-scope="scope">
          <span style="cursor: pointer;color: dodgerblue;padding: 1px 4px;overflow: hidden;text-overflow: ellipsis;white-space: nowrap;" @click="showKefuRemark(scope.row.kefuRemark);">{{scope.row.kefuRemark}}</span>
          <!-- 查看客服备注 -->
        </template>
      </el-table-column>

      <el-table-column align="center" label="操作" fixed="right" width="420">
        <template slot-scope="scope">
          <el-button
            size="small"
            type="primary"
            @click="addRemark(scope.row.id)"
            style="margin-top: 10px;"
          >添加备注</el-button>
          <el-button
              v-if="scope.row.status === 4"
              size="small"
              type="warning"
              @click="confirmOrder(scope.row.id)"
              style="margin-top: 10px;"
          >确认</el-button>
        </template>
      </el-table-column>
    </el-table>
    <!-- 页码 -->
    <template slot="footer">
      <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page.sync="listQuery.currentPage"
          :page-sizes="[10,20,30, 50]"
          :page-size="listQuery.pageSize"
          layout="total, sizes, prev, pager, next, jumper"
          :total="total"
      ></el-pagination>
    </template>
    <el-dialog
      title="客服备注"
      :visible.sync="dialogFormVisible"
      width="50%"
    >
      <span>{{ kefuRemark }}</span>
    </el-dialog>
  </d2-container>
</template>
<script>

import moment from 'moment/moment'
import { getOrderList, confirm, addRemark } from '@/api/merchant/service/order'
import SpecView from '@/components/product/specView.vue'

export default {
  name: 'serviceProduct',
  components: { SpecView },
  data () {
    return {
      kefuRemark: '',
      tableKey: 0,
      dialogStatus: '',
      textMap: {
        update: '编辑',
        create: '创建'
      },
      total: 0,
      keyWordManger_btn_add: false,
      keyWordManger_btn_edit: false,
      keyWordManger_btn_del: false,
      dialogFormVisible: false,
      list: [],
      form: {
        color: '', // 名称
        word: '' // 关键词
      },
      listQuery: {
        accountId: '',
        asStatus: '',
        createTimeEnd: '',
        createTimeStart: '',
        currentPage: 1,
        keyword: '',
        orderId: '',
        pageSize: 20,
        payStatus: '',
        pushStatus: '',
        shipStatus: '',
        status: ''
      },
      selectedTime: [], // 时间
      payList: [
        {
          value: 0,
          label: '未支付'
        },
        {
          value: 1,
          label: '已支付'
        }
      ],
      statusList: [
        {
          value: 0,
          label: '已关闭'
        },
        {
          value: 1,
          label: '待支付'
        },
        {
          value: 2,
          label: '未支付取消'
        },
        {
          value: 3,
          label: '已退款'
        },
        {
          value: 4,
          label: '待确认'
        },
        {
          value: 5,
          label: '进行中'
        },
        {
          value: 6,
          label: '已完成'
        }
      ],
      listLoading: false,
      rules: {
        word: [
          {
            required: true,
            message: '关键词',
            trigger: 'blur'
          },
          {
            min: 1,
            max: 20,
            message: '长度在 1 到 20 个字符',
            trigger: 'blur'
          }
        ],
        color: [
          {
            required: true,
            message: '请选择背景色',
            trigger: 'blur'
          }
        ]
      }
    }
  },
  created () {
    this.getSearch()
  },
  watch: {
    $route (to, from) {
      console.log('to', to)
      if (to.path == '/merchant/service/order' && from.path == '/merchant/service/order/edit') {
        this.getSearch(this.listQuery.currentPage)
      }
    }
  },
  methods: {
    clearBoth () {
      this.listQuery = {
        currentPage: 1,
        pageSize: 20,
        keyword: '',
        payStatus: '',
        status: '',
        accountId: '',
        orderId: ''
      }
      this.selectedTime == []
    },
    confirmOrder (id) {
      let that = this
      this.$prompt('输入备注', '确认订单，生成项目', {
        confirmButtonText: '确认',
        cancelButtonText: '取消',
        inputErrorMessage: '备注'
      }).then(({ value }) => {
        confirm({
          id: id,
          remark: value
        }).then(() => {
          that.$message({
            message: '项目已生成',
            type: 'success',
            center: true
          })
          that.getSearch(this.listQuery.currentPage)
        })
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '取消输入'
        })
      })
    },
    // 每页条数
    handleSizeChange (val) {
      this.listQuery.pageSize = val
      this.getSearch(val)
    },
    userDedtails (id) {
      let that = this
      console.log('id', id)
      that.$router.push({
        path: '/demo/user/userDetails',
        query: {
          id: id
        }
      })
    },
    // 当前页
    handleCurrentChange (val) {
      this.listQuery.currentPage = val
      this.getSearch(val)
    },
    getSearch (val) {
      this.getList(val)
    },
    getList (val) {
      let that = this
      var createTimeStart, createTimeEnd
      if (this.selectedTime == '' || this.selectedTime == null) {
        createTimeStart = ''
        createTimeEnd = ''
      } else {
        createTimeStart = moment(this.selectedTime[0]).format(
          'YYYY-MM-DD HH:mm:ss'
        )
        createTimeEnd = moment(this.selectedTime[1]).format(
          'YYYY-MM-DD HH:mm:ss'
        )
      }
      if (val) {
        this.listQuery.currentPage = val
      } else {
        this.listQuery.currentPage = 1
      }
      this.listQuery.createTimeStart = createTimeStart
      this.listQuery.createTimeEnd = createTimeEnd
      getOrderList(this.listQuery).then(res => {
        that.listLoading = true
        that.list = res.records
        that.total = parseInt(res.total)
        that.listLoading = false
      })
    },
    showKefuRemark (remark) {
      this.kefuRemark = remark
      this.dialogFormVisible = true
    },

    cancel () {
      let that = this
      that.dialogFormVisible = false
    },
    // 删除
    delCard (id) {
      let that = this
      this.$confirm('此操作将删除该关键词, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          removeProduct(id).then(res => {
            that.$message({
              message: '删除成功',
              type: 'success',
              center: true
            })
            that.getSearch()
          })
        })
        .catch(() => {
          that.$message({
            type: 'info',
            message: '已取消删除'
          })
        })
    },
    addRemark (id) {
      this.$prompt('请输入备注', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消'
      }).then(({ value }) => {
        addRemark(id, value).then(res => {
          this.$message({
            type: 'success',
            message: '添加成功!'
          })
          this.getSearch(this.listQuery.currentPage)
        })
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '取消输入'
        })
      })
    }
  }
}
</script>
<style scoped>
.span {
  width: 50px;
  height: 50px;
  display: block;
  margin: 0px auto;
  border: 1px solid rgba(0, 0, 0, 0.3);
}
</style>
